import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import parse from "html-react-parser";
import { MillisecondsToIndianTime } from "../../../util/millisecToTime/MilliSecToTime";
import DeleteComment from "../../popup/deleteComment/DeleteComment";
import moment from "moment/moment";

const BlogDetails = () => {
  const [slideImgs, setSlideImgs] = useState([]);
  const [showTrimedText, setShowTrimedText] = useState(true);
  const [showComments, setShowComments] = useState(true);
  const [commentData, setCommentData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedComment, setSelectedComment] = useState(null);

  const setModalShowButton = (type, comment) => {
    setModalShow(true);
    setModalType(type);
    setSelectedComment(comment);
  };

  const { id } = useParams();
  const { state } = useLocation();

  const getBlogsAndVideosComments = () => {
    axios
      .get(
        `https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/get/blogsAndVideosComments?docId=${id}_b&userId=4194`
      )
      .then((res) => {
        setCommentData(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getBlogsAndVideosComments();
  }, []);

  useEffect(() => {
    axios
      .get(
        `https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/get/blog/${id}`
      )
      .then((res) => {
        // Adjust this line if your API response structure is different
        setSlideImgs([res.data.data.coverImage]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  const updateBlogsAndVideosComments = (
    parentDocId,
    docId,
    deleteValue,
    markInappropriate
  ) => {
    axios
      .put(
        `https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/update/blogsAndVideosComments?parentDocId=${parentDocId}&docId=${docId}&isDelete=${deleteValue}&markInappropriate=${markInappropriate}`
      )
      .then((res) => {
        setModalShow(false);
        getBlogsAndVideosComments();
      })
      .catch((err) => {
        console.log("err", err);
      });
  };


  const formatFirestoreDate = (timestamp) => {
    if (!timestamp?._seconds) return "";
    return moment(new Date(timestamp._seconds * 1000)).format("DD MMM YYYY");
  };

  return (
    <div className="quickReadsPopupContainer">
      <div className="QrImageSlider">
        <Swiper
          navigation={{
            nextEl: ".nextIcon",
            prevEl: ".prevIcon",
            disabledClass: ".swiper-button-disabled",
          }}
          modules={[Navigation]}
          className="mySwiper"
          slidesPerView={1}
        >
          {slideImgs.map((item, ind) => (
            <SwiperSlide key={ind}>
              <img className="blogTitleImages" src={item} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="QrDetails">
        <div className="QRDetailsContainer">
          <div className="QrDetailsTitleDate">
            <h3>{state?.title}</h3>
            <span>{formatFirestoreDate(state.createdAt)}</span>
          </div>

          <div className="QrDescriptionContainer">
            <div className="QrDescription">
              {showTrimedText === true && state?.description ? (
                <>
                  {parse((state?.description).substring(0, 700))}
                  <span onClick={() => setShowTrimedText(false)}>
                    see more...
                  </span>
                </>
              ) : (
                state?.description && parse(state?.description)
              )}
            </div>
          </div>

          {/* =====================View Comments==================== */}

          {/* <div
            className="commentsParentcontainer"
            style={{ marginBottom: "20px" }}
          >
            <div
              className="commentSection"
              onClick={() => setShowComments(!showComments)}
              style={
                showComments === true
                  ? {
                      borderBottomLeftRadius: "0px",
                      borderBottomRightRadius: "0px",
                    }
                  : {
                      borderRadius: "5px",
                    }
              }
            >
              <h4>View All Comments ({commentData.length})</h4>
              <img src="/assets/chevronUp.png" alt="" />
            </div>

            {showComments === true && (
              <div className="commentSectionContainer">
                {commentData.map((item) => (
                  <div className="comments" key={item.docId}>
                    <div className="userProfile">
                      <img
                        src="/img/user.png"
                        alt=""
                        style={{ width: "20px" }}
                      />
                    </div>
                    <div className="userComment">
                      <h4 className="username">{item.userName}</h4>
                      <h4>{item.message}</h4>
                      <p>{MillisecondsToIndianTime(item.timestamp)}</p>
                    </div>

                    <div style={{ textAlign: "right" }}>
                      {item.isDelete ? (
                        <img
                          style={{ cursor: "pointer" }}
                          src="/img/restore.png"
                          title="Restore Comment"
                          alt="image"
                          width={"20px"}
                          onClick={() => {
                            setModalShowButton("restore", item);
                          }}
                        />
                      ) : (
                        <img
                          style={{ cursor: "pointer" }}
                          src="/img/delete.png"
                          alt="image"
                          title="Delete Comment"
                          width={"15px"}
                          onClick={() => {
                            setModalShowButton("delete", item);
                          }}
                        />
                      )}
                      {modalType === "delete" && selectedComment && (
                        <DeleteComment
                          actionType="delete"
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                          comment={selectedComment}
                          updateFunction={updateBlogsAndVideosComments}
                          updateParams={[
                            selectedComment.parentDocId,
                            selectedComment.docId,
                            true,
                            null,
                          ]}
                        />
                      )}

                      {modalType === "restore" && selectedComment && (
                        <DeleteComment
                          actionType="restore"
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                          comment={selectedComment}
                          updateFunction={updateBlogsAndVideosComments}
                          updateParams={[
                            selectedComment.parentDocId,
                            selectedComment.docId,
                            false,
                            null,
                          ]}
                        />
                      )}
                    </div>

                    <div style={{ textAlign: "right" }}>
                      {item?.markInappropriate ? (
                        <img
                          style={{ cursor: "pointer" }}
                          src="/img/checked.png"
                          alt="image"
                          width={"20px"}
                          onClick={() => {
                            setModalShowButton("appropriate", item);
                          }}
                        />
                      ) : (
                        <img
                          style={{ cursor: "pointer" }}
                          src="/img/report.png"
                          alt="image"
                          width={"20px"}
                          onClick={() => {
                            setModalShowButton("inAppropriate", item);
                          }}
                        />
                      )}
                      {modalType === "appropriate" && selectedComment && (
                        <DeleteComment
                          actionType="appropriate"
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                          comment={selectedComment}
                          updateFunction={updateBlogsAndVideosComments}
                          updateParams={[
                            selectedComment.parentDocId,
                            selectedComment.docId,
                            null,
                            false,
                          ]}
                        />
                      )}
                      {modalType === "inAppropriate" && selectedComment && (
                        <DeleteComment
                          actionType="inAppropriate"
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                          comment={selectedComment}
                          updateFunction={updateBlogsAndVideosComments}
                          updateParams={[
                            selectedComment.parentDocId,
                            selectedComment.docId,
                            null,
                            true,
                          ]}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;